import React from 'react';
import { Helmet } from 'react-helmet-async';

import HeroBanner from './HeroBanner';
import QuickServices from './QuickServices';
import MinisterMessage from './MinisterMessage';
import LatestNews from './LatestNews';
import PublicProcurement from './PublicProcurement';
import TimorianaSlider from '../Slider/Slider';
import Partners from '../Partners/Partner';
import InfoTab from '../InfoGraphic/InfoTab';
import { Section, SectionHeading } from '../Common/PageLayout';

/** Portal landing page. */
export default function Home() {
    return (
        <>
            <Helmet>
                <title>Ministry of Finance | Democratic Republic of Timor-Leste</title>
                <meta
                    name="description"
                    content="Official portal of the Ministry of Finance of Timor-Leste: State Budget documents, public spending, tenders, publications, taxation and customs services."
                />
                <meta
                    name="keywords"
                    content="Ministry of Finance, Timor-Leste, RDTL, State Budget, public spending, tenders, procurement, taxation, customs, statistics"
                />
            </Helmet>

            <HeroBanner />

            <Section tone="default" tight>
                <SectionHeading
                    overline="Featured"
                    title="In focus"
                    action={{ label: 'All news', to: '/latestnews' }}
                    rule={false}
                />
                <TimorianaSlider />
            </Section>

            <QuickServices />

            <MinisterMessage />

            <LatestNews />

            <PublicProcurement />

            <Section tone="default" bordered>
                <SectionHeading
                    overline="Open data"
                    title="Budget and revenue tracker"
                    description="Revenue collected and expenditure executed by the State, drawn from the Ministry's financial management systems."
                    action={{ label: 'All years', to: '/budgetandrevenueallyears' }}
                />
                <InfoTab />
            </Section>

            <Partners />
        </>
    );
}
